import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { WhyUs } from "@/components/WhyUs";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let frame;
        const raf = (time) => {
            lenis.raf(time);
            frame = requestAnimationFrame(raf);
        };
        frame = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(frame);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <main className="bg-[#FAFAFC] text-slate-900 antialiased" data-testid="landing-page">
            <Header />
            <Hero />
            <Marquee />
            <About />
            <Services />
            <Process />
            <WhyUs />
            <Testimonials />
            <Contact />
            <Footer />
        </main>
    );
}
